<template>
  <div class="interventions">
    <div class="header-intervention">
      <div class="intervention-type">
        {{ getTypeLabel() }}
      </div>
      <b-button-group size="sm" class="group">
        <b-button :pressed.sync="open" v-on:click="buttonTypeIntervention('open')" variant="outline-danger">En cours</b-button>
        <b-button :pressed.sync="close" v-on:click="buttonTypeIntervention('close')" variant="outline-danger">Terminées</b-button>
      </b-button-group>
    </div>

    <b-container class="interventions-list">
      <transition name="fade" mode="out-in">
        <b-alert class="cache" variant="warning" show v-if="cache"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cache activé <br> Tirez pour synchroniser ou <a href="#" v-on:click="sync">cliquez ici</a></b-alert>
      </transition>
      <div class="message" v-if="!isNotEmpty(interventions) && !loading">
        <i class="fa fa-info" aria-hidden="true"></i> <br>
        Aucune intervention de {{getTypeLabel()}} disponible.
      </div>
      <div class="intervention" v-if="!cache && loading && !isNotEmpty(interventions)">
        <div class="shimmer shimmer-progress"></div>
        <div class="shimmer shimmer-label-small"></div>
        <div class="shimmer shimmer-label-small"></div>
        <div class="shimmer shimmer-label-small"></div>
      </div>
        <div v-for="intervention in orderBy(interventions, 'dateRdv')" v-on:click="goToIntervention(intervention.interventionId)" v-if="type !== 'audit'" class="intervention">

          <b-progress :max="100">
            <b-progress-bar :value="progressBar(intervention, 'percent')" :variant="progressBar(intervention,'className')" striped :animated="progressBar(intervention,'animated')">
               {{ progressBar(intervention,'value') }}
            </b-progress-bar>
          </b-progress>

          <div class="type">
            {{intervention.typeReference}}
          </div>
          <div class="label">
            NRO : {{intervention.nro === null ? intervention.codeNro : intervention.nro}}
          </div>
          <div class="label" v-if="intervention.auditinfra">
            PM : {{intervention.nomPm}}
          </div>
          <div class="label" v-if="!intervention.auditinfra">
            Jeton : {{intervention.jeton}}
          </div>
          <div class="label">
            RDV Client :
            <i v-if="intervention.rdvClient" class="fa fa-check green-color" aria-hidden="true"></i>
            <i v-if="!intervention.rdvClient" class="fa fa-times red-color" aria-hidden="true"></i>
          </div>
          <div class="label">
            Date du RDV : {{ formatDate(intervention.dateRdv) }}
          </div>
          <!--<div class="label">-->
            <!--Date debut : {{ formatDate(intervention.dateDebut) }}-->
          <!--</div>-->
          <!--<div class="label">-->
            <!--Date fin : {{ formatDate(intervention.dateFin) }}-->
          <!--</div>-->
        </div>
      <div v-for="intervention in orderBy(interventions, 'dateRdv')" v-on:click="goToIntervention(intervention.interventionId)" v-if="type === 'audit'" class="intervention">

        <b-progress :max="100">
          <b-progress-bar :value="progressBar(intervention, 'percent')" :variant="progressBar(intervention,'className')" striped :animated="progressBar(intervention,'animated')">
            {{ progressBar(intervention,'value') }}
          </b-progress-bar>
        </b-progress>

        <div class="type">
          {{intervention.descr}}
        </div>
        <div class="label">
          NRO : {{intervention.nro}}
        </div>
        <div class="label">
          Jeton : {{intervention.jeton}}
        </div>
        <div class="label">
          RDV Client :
          <i v-if="intervention.rdvClient" class="fa fa-check green-color" aria-hidden="true"></i>
          <i v-if="!intervention.rdvClient" class="fa fa-times red-color" aria-hidden="true"></i>
        </div>
        <div class="label">
          Date du RDV : {{ formatDate(intervention.dateRdv) }}
        </div>
        <!--<div class="label">-->
        <!--Date debut : {{ formatDate(intervention.dateDebut) }}-->
        <!--</div>-->
        <!--<div class="label">-->
        <!--Date fin : {{ formatDate(intervention.dateFin) }}-->
        <!--</div>-->
      </div>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'
import PullToRefresh from '../assets/js/pulltorefresh'

export default {
  name: 'Interventions',
  data () {
    return {
      open: true,
      close: false,
      status: 'open',
      type: null,
      cache: false,
      interventions: [],
      loading: false
    }
  },
  methods: {
    isNotEmpty: function (interventions) {
      if (interventions === null) {
        return 0
      }

      return interventions.length === 0 ? 0 : 1
    },
    buttonTypeIntervention: function (status) {
      if (status === 'open') {
        this.open = true
        this.close = false
      } else {
        this.open = false
        this.close = true
      }
      this.status = status
      this.interventions = []
      this.$router.push('/interventions/' + this.type + '/' + status)
    },
    getInterventionsList: function (cb) {
      this.loading = true
      this.$http.get('interventions/' + this.type + '/' + this.status).then(response => {
        this.response = response.json().then((data) => {
          this.interventions = data
          this.interventions.map(intervention => {
            if (intervention.typeId === 15 || intervention.typeId === 16) {
              intervention.auditinfra = true
            } else {
              intervention.auditinfra = false
            }
          })
          this.cache = false
          this.$setItem(this.type + '_' + this.status, data, function (err, values) {
            if (err) {
              alert(err)
            }
          })

          if (typeof cb === 'function') {
            cb()
          }

          this.loading = false
        })
      }, (response) => {
        if (typeof cb === 'function') {
          cb()
        }
        if (!this.cache) {
          this.loading = false
          this.$toast.bottom('Une erreur est survenue lors de la récupération des interventions')
        }
      })
    },
    getTypeLabel: function () {
      if (this.type === 'postprodsav') {
        return 'PostProduction / SAV'
      } else if (this.type === 'prod') {
        return 'Production'
      } else {
        return 'Audit'
      }
    },
    formatDate: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    progressBar: function (intervention, key) {
      let data = []
      let a = moment(new Date())
      let b = moment(intervention.dateRdv).add(2, 'hours')
      let diff = b.diff(a)
      let duration = moment.duration(diff)
      data.animated = false

      if (this.close) {
        let a = moment(intervention.dateDebut)
        let b = moment(intervention.dateFin)
        let diff = b.diff(a)
        let duration = moment.duration(diff)
        let label = null

        if (duration.days() !== 0) {
          label = 'Durée : ' + duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
        } else {
          label = 'Durée : ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
        }

        data.percent = 100
        data.className = 'success'
        data.value = label
        // data.animated = false
        return data[key]
      }

      // Calcul
      if (diff < 0) {
        data.percent = 100
        data.className = 'danger'
        data.value = 'Intervention en retard'
      } else {
        if (duration.asHours() <= 1.5 && duration.asDays() < 1) {
          data.percent = duration.asHours() / 1.5 * 100
          data.value = Math.round(duration.asMinutes(), 0) + ' Minutes'
          if (data.percent >= 0 && data.percent <= 30) {
            data.className = 'danger'
          }
          if (data.percent >= 30 && data.percent <= 60) {
            data.className = 'warning'
          }
        } else {
          data.className = 'success'
          data.percent = 100
          data.value = 'dans ' + duration.days() + ' j ' + duration.hours() + ' h  ' + duration.minutes() + ' m'
        }
      }
      if (intervention.dateDebut !== '0000-00-00 00:00:00') {
        let a = moment(new Date())
        let b = moment(intervention.dateDebut)
        let diff = a.diff(b)
        let duration = moment.duration(diff)
        let label = null

        if (duration.days() !== 0) {
          label = 'En cours depuis ' + duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
        } else {
          label = 'En cours depuis ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
        }

        data.percent = 100
        data.className = 'primary'
        data.value = label
      }
      return data[key]
    },
    goToIntervention: function (interventionId) {
      this.$router.push(`/intervention/${interventionId}`)
    },
    getCache: function (context, value) {
      this.$getItem(value, function (err, values) {
        if (err) {
          this.getInterventionsList()
          return
        }
        if (values === null) {
          context.getInterventionsList()
          return
        }
        context.cache = true
        context.interventions = values
      })
    },
    buttonURL: function (status) {
      if (status === 'open') {
        this.open = true
        this.close = false
      } else {
        this.open = false
        this.close = true
      }
      this.status = status
    },
    sync: function () {
      this.getInterventionsList()
    }
  },
  computed: {
    btnStates () {
      return this.buttons.map(btn => btn.state)
    }
  },
  mounted: function () {
    this.type = this.$route.params.type
    this.status = this.$route.params.status
    this.buttonURL(this.status)

    let _this = this
    PullToRefresh.init({
      mainElement: '.interventions-list',
      onRefresh: function (cb) { _this.getInterventionsList(cb) }
    })
    this.getCache(this, this.type + '_' + this.status)
  },
  watch: {
    '$route.params.status' (newId, oldId) {
      this.status = this.$route.params.status
      this.type = this.$route.params.type
      this.buttonURL(this.status)
      this.getCache(this, this.type + '_' + this.status)
    },
    '$route.params.type' (newId, oldId) {
      this.status = this.$route.params.status
      this.type = this.$route.params.type
      this.buttonURL(this.status)
      this.getCache(this, this.type + '_' + this.status)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Interventions.vue